/*    
<summary>
  This functional component "AddCmsDetails" allows store to change/delete/add details which are visible to customer.
</summary>
<returns>Returns JSX</returns>
*/
import { observer } from "mobx-react";
import React, { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import AddCmsDetailsForm from "../forms/add-edit-cms-details-form";
import { useStore } from "../../../../contexts/store-provider";
import toast from "react-hot-toast";
import { formatMessage } from "../../../../translations/format-message";

interface IProps {
    id: number;
    storeId: number;
    modalClosed: () => void;
}

const AddCmsDetails = (props: IProps) => {
    const { storeCmsStore } = useStore();
    
    const { GetStoreCmsByIdService,
        addUpdateStoreCmsState,
        UpdateStoreCmsService,
        resetAddUpdateStoreCmsState,
        resetGetStoreCmsState,
        store,
        cmsStoreDetails
    } =  storeCmsStore;


    useEffect(() => {
      if (props.id > -1) {
        GetStoreCmsByIdService(props.storeId);
      }
    }, []);
    /**
       * This function closes the pop up modal .
       */
      const onModalClosed = () => {
        resetAddUpdateStoreCmsState();
        resetGetStoreCmsState();
        props.modalClosed();
      };

      /**
         * This function adds the staff when "Id < 0" and updates the Existing staff when Id > 0 by providing form values to the
         * correponding function
         */
        const onSubmitForm = (values: any) => {
          UpdateStoreCmsService({
              ...values,
              StoreId: props.storeId,
            });
        };
      
        /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateStoreCmsState.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateStoreCmsState.success) {
      if (props.id === -1) toast.success(formatMessage("added_success"));
      else toast.success(formatMessage("updated_success"));
      GetStoreCmsByIdService(props.storeId);
      onModalClosed();
    }
  }, [addUpdateStoreCmsState.success]);

    return (
        <React.Fragment>
      
      <AddCmsDetailsForm
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        initialValues={cmsStoreDetails}
      />
    </React.Fragment>
    );
};

export default observer(AddCmsDetails);
